// extracted by mini-css-extract-plugin
module.exports = {"book-demo-wrapper":"BookDemo_book-demo-wrapper__ewqkX"};